const re = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^\da-zA-Z]).{8,45}$/;

const password = {
    name: "password",
    validate: (password) => password == null || password === "" || re.test(String(password)),
};
exports.password = password;
